/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import * as React from 'react';
import { Accordion, AccordionList, Heading, Icon, Paper, Stack, TwoWayToggle } from '@vaisala/rockhopper-components';
import { VaiIcon} from '@vaisala/rockhopper-design-tokens';
import { NCFilesInfoList } from './NCFilesInfoList';

import { NCInfo } from '../state/project/@types';
import { PageProcessStatus} from '../pages/DataManagementPage';
import styled from 'styled-components';

interface Props {
    processStatus : PageProcessStatus;
    selectedMode : 'LEFT'|'RIGHT';
    handleToggle : (e : string) => void;
    history_nc_info? : {[key : string] : NCInfo[]};
    history_status? : boolean;
    new_nc_info? : {[key : string] : NCInfo[]};
    new_nc_status? : boolean;
    untracked_nc_info? : {[key : string] : NCInfo[]};
    date? : string;
    new_data? : boolean;
    fetchingFiles: boolean;
}

const NcInfoContainer = styled(Paper)`

    position: relative;
    width: 49%;
    height: 100%;

    .header-stack{
        position: relative;
        margin-bottom : 15px;
        height: 7%;
    };

    .accordion-style{
        position : relative ;
        height: 90%;
        margin-top : 15px;
        overflow-y: auto;
    }

`;

export const NCFilesInfo : React.FC<Props> = (props) => {
    
    const {
        processStatus,
        history_nc_info,
        history_status,
        new_nc_info,
        new_nc_status,
        untracked_nc_info,
        date,
        new_data,
        selectedMode,
        handleToggle,
        fetchingFiles,


    } = props

    const [openedAccordion, setOpenedAccordion] = React.useState(new_data?'new_files':'history');

    const handleAccordionChange = (activeKeys : any, currentAccordionKey : any, isExpanded : any) => {
        setOpenedAccordion(currentAccordionKey)
    }

    return (
    <NcInfoContainer>
        <Stack className='header-stack' direction='row' justify='space-between' align='center'>
            <Heading level = {2} >
                {
                (selectedMode === "LEFT")?
                ((history_nc_info === undefined) ?
                "No data loaded in the current project" :
                "Campaign data information") :
                (date === "")?"Day specific data information":(new Date(date + "T00:00:00")).toLocaleDateString(undefined, {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})
                }
            </Heading>
            <TwoWayToggle
                disabled={processStatus !== "NONE"}
                selected={selectedMode}
                onChange={(selected) => handleToggle(selected)}
                rightText="Daily data"
                leftText="All data"
            />

        </Stack>
        <div className='accordion-style'>
            <AccordionList
                exclusive={true}
                onChange={handleAccordionChange}
                defaultKeys={openedAccordion}
                mode="narrow"
            >   
            {
                (new_nc_info !== undefined && new_data)?
                <Accordion
                    accordionKey={'new_files'}
                    title={"New files detected"}
                    icon={selectedMode === "RIGHT"?<Icon name={new_nc_status?VaiIcon.AlertOk:VaiIcon.AlertWarning}/>:null}
                >
                    <NCFilesInfoList
                        date={date !== undefined}
                        nc_info={new_nc_info}
                        fetchingFiles={fetchingFiles}
                        selectedMode={selectedMode}
                    />
                </Accordion>:
                null
            }
            {
                (history_nc_info !== undefined)?
                <Accordion
                    accordionKey={'history'}
                    title={"Data history"}
                    icon={selectedMode === "RIGHT"?<Icon name={history_status?VaiIcon.AlertOk:VaiIcon.AlertWarning}/>:null}
                >   
                    <NCFilesInfoList
                        date={date !== undefined}
                        nc_info={history_nc_info}
                        fetchingFiles={fetchingFiles}
                        selectedMode={selectedMode}

                    />

                </Accordion> :
                null
            }
            {
                (untracked_nc_info !== undefined && new_data)?
                <Accordion
                    accordionKey={'untracked'}
                    title={"Invalid files detected"}
                >
                    <NCFilesInfoList
                        date={date !== undefined}
                        nc_info={untracked_nc_info}
                        fetchingFiles={fetchingFiles}
                        selectedMode={selectedMode}

                    />

                </Accordion> :
                null
            }

            </AccordionList>            
        </div>
    </NcInfoContainer>
    );
};